import { Component, OnInit } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { CalendarService } from '../../services/calendar.service';

declare let $: any;

@Component({
  selector: 'app-navbar-calendar',
  templateUrl: './navbar-calendar.component.html',
  styleUrls: ['./navbar-calendar.component.css']
})
export class NavbarCalendarComponent implements OnInit {

  public tDate = new Date(2010, 11, 1);
  constructor(
    private datePicker: MatNativeDateModule,
    public calendarSvc: CalendarService
  ) { }

  ngOnInit() {
    this.tDate = this.calendarSvc.targetDate;
  }


  public dateTextChange(event: KeyboardEvent) {
    // console.log("dateTextChange", event, this.calendarSvc.targetDate );
    if (event.keyCode === 13) {
      this.changeDateIfNecessary(event);
    }
  }

  public dateTextBlur(event: any) {
    // console.log("dateTextBlur", event, this.calendarSvc.targetDate );
    this.changeDateIfNecessary(event);
  }

  private changeDateIfNecessary(event: any) {
    console.log(event);
    var tDate = this.formatDateFromCalendarInput(event.srcElement);
    if (tDate != null && tDate.toString() !== "Invalid Date") {
      console.log("changeDateIfNecessary", tDate);
      this.switchDate(tDate);
      this.forceDropdownClosed();
    }
  }

  private formatDateFromCalendarInput(element: any): Date {
    var value = element.value;
    var parsedDate = new Date(value);
    console.log(parsedDate);
    if (parsedDate.toString() === "Invalid Date" || parsedDate.getDay() === NaN) {
      console.log("invalid date", element.value, parsedDate);
    } else {
      return parsedDate;
    }
    return null;
  }

  public onChange(event: Date) {
    var targetDate = new Date(event);
    this.switchDate(targetDate);
    this.forceDropdownClosed();
  }

  private switchDate(targetDate: Date) {
    this.calendarSvc.redirectToDate(targetDate);
  }

  public calendarClicked(event: any) { 

    //This detects any clicked event on the calendar and dismisses the calendar window if the user selected a date.
    //This is redundant if the date changes, but the control does not fire an event if the user clicks on the date that is already selected.
    //in that scenario, we just want the calendar to be dismissed.
    if (event.target.classList.contains("mat-calendar-body-selected")) { 
      this.forceDropdownClosed();
    }

  } 

  public forceDropdownOpen(e: any) {
    // console.log("stopPropagation")
    e.stopPropagation();
  }

  private forceDropdownClosed() {
    $("#main-container").click();
    // $("#page-header-themes-dropdown-calendar").dropdown("toggle");
  }

}
